__turbopack_context__.v({
  "accordion": "vWQpqG_accordion",
  "accordionToggle": "vWQpqG_accordionToggle",
  "content": "vWQpqG_content",
  "contentParagraph": "vWQpqG_contentParagraph",
  "icon": "vWQpqG_icon",
  "iconColumn": "vWQpqG_iconColumn",
  "title": "vWQpqG_title",
  "titleSection": "vWQpqG_titleSection",
});
